import { PortalApiError } from '@afterpaytouch/portal-api/types'

export enum OAuthErrorCode {
  InvalidRequest = 'invalid_request',
  UnauthorizedClient = 'unauthorized_client',
  UnsupportedResponseType = 'unsupported_response_type',
  InvalidScope = 'invalid_scope',
  ServerError = 'server_error',
  AccessDenied = 'access_denied',
}

export type OAuthScope = 'read_payment_details' | 'read_user_info' | 'create_checkout' | null
export type OAuthResponseType = 'authorization_code' | 'refresh_token' | null

export interface OAuthParams {
  readonly clientId?: string
  readonly responseType?: OAuthResponseType
  readonly redirectUri?: string
  readonly scope?: string
  readonly state?: string
}

export interface OAuthState extends OAuthParams {
  clientName?: string
  scopeAndDescription?: ScopeResponseRepresentation[]
  consumerEmailId: string | null
  error?: OAuthError
}

export type OAuthAccessDeniedError = 'access_denied'

export const OAUTH_ACCESS_DENIED_ERROR = 'access_denied'

export type OAuthError = PortalApiError | OAuthAccessDeniedError

export interface OAuthHttpRequest {
  clientId: string
  scopes: OAuthScope[]
  grantType: OAuthResponseType
  redirectUri: string
}

export interface AuthorisationResponse {
  code: string
}

export interface ConfirmAccessResponse {
  clientName: string
  scopeAndDescription: ScopeResponseRepresentation[]
  consumerEmailId: string
}

export interface ScopeResponseRepresentation {
  scope: string
  description: string[]
}

export type OAuthAuthorizationSuccessCallbackUrlArgs = AuthorisationResponse & {
  state?: string
}

export interface OAuthAuthorizationFailedCallbackUrlArgs {
  error: OAuthErrorCode | string
  state?: string
}

export interface OAuthAuthorizationFlow {
  oAuthAuthorization: (isTrusted: boolean) => Promise<void>
}
